// @flow

import type { SchemaTableOptionCallback } from "../types";

function resolveBoolean(option?: boolean | SchemaTableOptionCallback, row: Object): boolean {
  if (!option) {
    return false;
  }

  if (typeof option === "boolean") {
    return option;
  }

  if (typeof option === "function") {
    return option(row);
  }

  return true;
}

function resolveNumber(option?: number | SchemaTableOptionCallback, row: Object): ?number {
  if (!option) {
    return undefined;
  }

  if (typeof option === "number") {
    return option;
  }

  if (typeof option === "function") {
    return option(row);
  }

  return undefined;
}

function resolveString(option?: string | SchemaTableOptionCallback, row: Object): ?string {
  if (!option) {
    return undefined;
  }

  if (typeof option === "boolean") {
    return option;
  }

  if (typeof option === "function") {
    return option(row);
  }

  return undefined;
}

function resolveDate(option?: string | SchemaTableOptionCallback, row: Object): ?Date {
  if (!option) {
    return undefined;
  }

  if (typeof option === "string") {
    return new Date(option);
  }

  if (typeof option === "function") {
    return new Date(option(row));
  }

  return undefined;
}

export default {
  resolveBoolean,
  resolveNumber,
  resolveString,
  resolveDate,
};
